<template>
<div>
  <image-uploader
    :id="data.id"
    :debug="data.debug"
    :maxWidth="data.maxWidth"
    :maxHeight="data.maxHeight"
    :quality="data.quality"
    :autoRotate=data.autoRotate
    :outputFormat="data.outputFormat"
    :preview=data.preview
    :className="data.className"
    :capture="data.capture"
    :accept="data.accept"
    :doNotResize="data.doNotResize"
    @input="data.input"
    @onUpload="data.onUpload"
    @onComplete="data.onComplete"
  >

    <label v-bind:for="data.id" slot="upload-label" class="img-label">
      <img v-if="data.image && data.image.dataUrl" v-bind:src="data.image.dataUrl" class="hit-img-responsive">

    <figure v-if="!data.image || !data.image.dataUrl">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 32 32">
        <path class="path1" d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"></path>
      </svg>
    </figure>

    </label>

  </image-uploader>

</div>
</template>

<script>

import ImageUploader from 'vue-image-upload-resize'

export default {

  props: {settings: Object},

  components: {
    ImageUploader
  },

  data () {
    var def = {

      image: null,
      id: new Date().getTime() + Math.random(0, 9) + '',
      debug: 1,
      maxWidth: 250,
      maxHeight: 250,
      quality: 0.7,
      autoRotate: true,
      outputFormat: 'verbose',
      preview: false,
      className: ['fileinput'],
      capture: 'false',
      accept: 'video/*,image/*',
      doNotResize: "['gif', 'svg']",
      input: this.setImage,
      onUpload: this.startImageResize,
      onComplete: this.endImageResize,
      onSave: false

    }

    if (typeof this.settings === 'object') { def = Object.assign(def, this.settings) }

    return {
      data: def,
      hasImage: false,
      ID: new Date().getTime() + Math.random(0, 9)
    }
  },
  methods: {
    getID () {
      return this.ID + ''
    },
    setImage: function (output) {
      this.hasImage = true
      this.data.image = output

      if (typeof this.data.onSave === 'function') { this.data.onSave(output) }
    },

    startImageResize () {},
    endImageResize () {}

  }
}

</script>

<style>
input[type='file'].fileinput {
  display: none;
}
.img-label{
  cursor: pointer;
}
</style>
